export default "__VITE_ASSET__pcmQoZQm__"